import { render, staticRenderFns } from "./b22.vue?vue&type=template&id=f27e2f40&scoped=true&"
import script from "./b22.vue?vue&type=script&lang=js&"
export * from "./b22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27e2f40",
  null
  
)

export default component.exports